var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaste2 = function SvgPaste2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    fill: "none",
    viewBox: "0 0 12 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1E3D",
    fillRule: "evenodd",
    d: "M1.333 0h8v1.333h-8v9.334H0V1.333C0 .597.597 0 1.333 0M3 5.35h1V4h2.1V3H4a1 1 0 0 0-1 1zM8.9 3v1H11v1.35h1V4a1 1 0 0 0-1-1zm0 11v-1H11v-1.35h1V13a1 1 0 0 1-1 1zm-2.8 0v-1H4v-1.35H3V13a1 1 0 0 0 1 1zM3 7.15h1v2.7H3zm9 2.7h-1v-2.7h1z",
    clipRule: "evenodd"
  })));
};
export default SvgPaste2;